var render, staticRenderFns
import script from "./BaseControl.vue?vue&type=script&lang=js"
export * from "./BaseControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e7d5c72')) {
      api.createRecord('1e7d5c72', component.options)
    } else {
      api.reload('1e7d5c72', component.options)
    }
    
  }
}
component.options.__file = "resources/js/teacher/vue/controls/BaseControl.vue"
export default component.exports